<!--
 * Path: packages/frontend/src/features/browser/components/entityHeader/EntityHeaderMain.vue
 * Task: Wrapper container assembling the modular header components (strictly meta info, NO toolbars).
 * Refactoring: Migrated active entity dependency from editorStore to the dedicated workspaceStore.
-->
<template>
  <div v-if="displayEntity" class="px-4 py-2 d-flex align-center flex-nowrap flex-shrink-0 w-100 theme-header-boundary" style="gap: 16px; min-width: 0;">
    <!-- LEFT: Icon, Title, Timestamp and ID -->
    <div class="d-flex align-center flex-shrink-0 flex-grow-1" style="min-width: 0; max-width: 100%;">
      <EntityHeaderTitlePanel
        :entity="displayEntity"
        :is-secondary="isSecondary"
        class="w-100"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue';
import { useWorkspaceStore } from '@/store/workspace';
import type { Entity } from '@/core/types/editor';
import { FormContextKey } from '@/core/keys';
import EntityHeaderTitlePanel from './EntityHeaderTitlePanel.vue';

interface Props {
  entity?: Entity | null;
  isSecondary?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  entity: null,
  isSecondary: false
});

const workspaceStore = useWorkspaceStore();
const formContext = inject(FormContextKey, null);

const displayEntity = computed<Entity | null>(() => {
  if (props.entity) return props.entity;
  if (formContext) return formContext.entity.value;
  return props.isSecondary
    ? workspaceStore.secondarySelectedEntity
    : workspaceStore.selectedEntity;
});
</script>

<style scoped>
.theme-header-boundary {
  /* Using standard surface background to blend properly */
  background-color: rgb(var(--v-theme-surface)) !important;
}
</style>
